module.exports = __webpack_public_path__ + "img/pic_l.a1d53b72.png";